<section class="fixed inset-0 flex flex-col h-dvh w-dvw bg-background_pink_primary overflow-auto">
  <div
    class="mx-auto tablet-lg:py-1.5 pt-[10px] w-full max-w-[1500px] px-4 tablet-lg:px-8 flex items-center justify-between shrink-0"
  >
    <div
      class="flex items-center justify-between mt-[1px] w-full mx-auto max-laptop-sm:pr-0 max-w-[1500px] h-[4.5rem] md:h-[5rem] lg:h-[5.5rem]"
    >
      <nav>
        <ul class="flex justify-between w-full">
          <li class="flex items-center max-mobile-lg:mr-2">
            <a class="mr-5 block max-w-[9rem] md:max-w-[10rem]" [routerLink]="'/login'">
              <svg
                role="img"
                aria-hidden="true"
                class="w-full fill-current text-red"
                viewBox="0 0 524 94"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="m86.48 2.25h24.77l21.05 64.56h1.24l21.04-64.56h23.67l-32.53 89.45h-28.24l-31-89.45z"></path>
                <path d="M209.68 2.25H186.15V91.7H209.68V2.25Z"></path>
                <path
                  d="m304.5 91.7h-27.83l-30.04-39.67h-1.24v39.67h-23.54v-89.45h23.54v37.47h1.24l27.69-37.47h27.27l-32.81 42.52 35.72 46.93z"
                ></path>
                <path d="M332.87 2.25H309.34V91.7H332.87V2.25Z"></path>
                <path
                  d="m345.44 2.25h24.23l31.97 50.43h1.25v-50.43h23.53v89.45h-22.15l-34.05-53.28h-1.24v53.28h-23.54v-89.45z"
                ></path>
                <path
                  d="m523.4 42.38h-45.4l5.59 16.15h15.84c-2.18 8.57-7.22 13.74-15.08 15.4-3.165 0.6699-6.435 0.6699-9.6 0-10.86-2.29-16.33-11.29-16.33-26.69 0-15.84 5.57-25.1 16.29-27.45 3.217-0.7149 6.553-0.7149 9.77 0 2.835 0.5772 5.493 1.8204 7.753 3.627 2.261 1.8065 4.059 4.1246 5.247 6.763h24c-5.03-19.33-19.48-29.98-41.34-30.18h-1.14c-27.61 0.25-43.4 17.19-43.4 47.24 0 27.85 14 44.4 39.08 46.28 1.61 0.11 3.24 0.17 4.89 0.17s3.28-0.06 4.89-0.17c25-1.88 39.08-18.43 39.08-46.28 0-1.66 0-3.28-0.14-4.86"
                ></path>
                <path
                  d="m14.3 43.63c0.43-1.88-0.7-1.46-1.62-0.85s-12.68 11.31-12.68 27.69 14.41 20.83 18.27 21.09v-21.09c-7.65 0-6.54-15.64-4-26.84"
                ></path>
                <path
                  d="m52.51 91.7-18.91-54.48c-0.8 1.72-1.5433 3.47-2.23 5.25-3.2163 8.2225-4.9106 16.961-5 25.79v23.44h26.14z"
                  class="fill-current text-viking_yellow"
                ></path>
                <path d="m73.06 2.27c-15.23 1.32-30.7 16.11-39.46 34.95l18.91 54.48h51.55l-31-89.43z"></path>
              </svg>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <div class="max-w-530 mx-auto h-full w-full pt-10 p-4 tablet-sm:p-8 rounded-xl">
    @if (state === OrganizationEmailVerificationState.Loading) {
      <app-loading [scope]="organizationScope" />
    } @else if (state === OrganizationEmailVerificationState.Verified) {
      <app-verified [email]="email" [scope]="organizationScope" />
    } @else if (state === OrganizationEmailVerificationState.Error) {
      <app-error [error]="error" [email]="email" [scope]="organizationScope" />
    }
  </div>
</section>
